import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FieldType } from '@ngx-formly/material';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';

@Component({
  selector: 'al-text-input-type',
  templateUrl: './al-text-input-type.component.html',
  styleUrls: ['./al-text-input-type.component.scss']
})
export class AlTextInputTypeComponent extends FieldType implements OnInit {

  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  documentId!: string;
  controlfield!: string;

  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService) {
    super();
  }

  override ngOnInit(): void {
    
    this.dbName = localStorage.getItem('dbname') as string;

    this.dataSharingService.tabIdChanges$.subscribe({
      next: (pageId:any) => {
        this.pageId = pageId as string;
      }
    })

    this.documentId = localStorage.getItem('doc-id') as string;
    this.pageId = localStorage.getItem('page-id') as string;

    this.attributeValueService.loadCurrentAttributeValue('', this.documentId, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto:any) => {
        JSON.parse(currentAttributeValueDto.controlData);
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  valueChangeFn(key: any, id: any, event: any) {
    let formData:any = {};
    formData[key] = event.target.value;

    this.attributeValueService.createAttributValueInfo(this.documentId, this.pageId, formData, key, id, this.dbName).subscribe({
      next: (data:any) => {
        console.log(data)
      },
      // error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }
}
